import { getBackbone, getBackboneFile, postBackbone, putBackbone } from '@/library/http';

export const getWorkFlows = async (
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  itemId: string,
  uuid: string,
  workflowIds: string[],
  status: string,
  cancelling: boolean | null,
  dateFrom: string,
  dateTo: string,
  inputVariables: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  if (sortBy?.length) filter += `&orderBy=${sortBy}`;
  if (itemId?.length) filter += `&itemId=${itemId}`;
  if (uuid?.length) filter += `&uuid=${uuid}`;
  workflowIds?.forEach((id) => {
    if (id?.length) filter += `&workflowIds=${encodeURIComponent(id)}`;
  });
  if (status?.length) filter += `&status=${status}`;
  if (dateFrom?.length) filter += `&from=${dateFrom}`;
  if (dateTo?.length) filter += `&to=${dateTo}`;
  if (inputVariables?.length) filter += `&inputVariables=${inputVariables}`;

  if (cancelling === null) {
    filter += `&cancelling=false`;
  } else if (cancelling === true) {
    filter += `&cancelling=true`;
  }

  return getBackbone(`/workflows/?limit=${limit}&skip=${skip}${filter}`);
};

export const getWorkflowById = (id: string) => getBackbone(`/workflows/${id}`);

export const preResolveAction = (data: any) => postBackbone('/engine/preval/resolve', data);

export const resolveAction = (data: any) => postBackbone('/engine/resolve', data);

export const authResolveAction = (data: any) => postBackbone('/engine/preauth/resolve', data);

export const getRelationsByWorkflow = (id: string) => getBackbone(`/relations/by-workflow/${id}`);

export const getRelationsByItem = (id: string) => getBackbone(`/relations/by-item/${id}`);

export const refreshStatus = (id: string) => putBackbone(`/workflows/refresh-workflow-status/${id}`);

export const abandonWorkflow = (id: string) => putBackbone(`/workflows/abandon/${id}`);

export const getWorkflowNames = () => getBackbone('/workflows/names/distinct');

export const downloadRoleCompositions = () => getBackboneFile('/role-composition-v2/export');
